let runningGetAllProducts = false;
let callbacks = [];
localStorage.removeItem('allProducts');

function allProductsLoader(callbackFunction) {
  let allProducts = {};
  let runCallback = true;
  callbacks.push(callbackFunction);
  
  function getAllProducts(url) {
    $.get(url, function(productsRaw) {
      let products = JSON.parse(productsRaw);
      allProducts = {...allProducts,...products.products};// merge two objects
      if (products.total > Object.keys(allProducts).length) {
        getAllProducts(products.next);
      } else {
        try {
          const keys = Object.keys(allProducts);
   		  let groupCount = 0;
          let partsCount = 0;
          let part = {};
   		  for(let i = 0; i < keys.length; i++){
            groupCount++;
            if (groupCount > 99) {
              localStorage.setItem('allProducts'+partsCount, JSON.stringify(part));
              partsCount++;
              groupCount = 0;
              part = {};
            }
            part[keys[i]] = allProducts[keys[i]];
          }
          localStorage.setItem('allProducts'+partsCount, JSON.stringify(part));
          
          localStorage.setItem('allProductsCacheTime2', Date.now());
        } catch (error) {
  		  console.error(error);
        }
        if (runCallback) {
          callbacks.forEach(element => element(expandSizes(allProducts)));
          //callbackFunction(allProducts);
        }
      }
    }).fail(function(){
      getAllProducts(url);
    });
  }
  
  function expandSizes(allProds) {
    for (const handle of Object.keys(allProds)) {
      for (let i=0; i < allProds[handle]['images'].length; i++) {
        const imagePath = allProds[handle]['images'][i]['url'];
        for (const size of allProds[handle]['images'][i]['dimensions']) {
          allProds[handle]['images'][i]['sizes'][size] = imagePath.replace('105x',size+'x');
        }
      }
    }
    return allProds;
  }
  
  function getFromLocalStorage() {
    let count = 0;
    let allProducts = {};
    let loading = true;
    while (loading) {
      let part = localStorage.getItem('allProducts'+count);
      if (part) {
        allProducts = {...allProducts,...JSON.parse(part)};
      } else {
        loading = false;
      }
      count++;
    }
    
    return allProducts;
  }
  
  if (!localStorage.getItem('allProductsCacheTime2') || Date.now() - localStorage.getItem('allProductsCacheTime2') > 1000 *60*60) {//1 hour expiry
    //console.log('re-loading');
    let allProds = getFromLocalStorage();
    
    if (Object.keys(allProds).length !== 0) {
      callbackFunction(expandSizes(allProds));
      runCallback = false;
    }
    if (!runningGetAllProducts) {
      getAllProducts('/pages/all_products');
      runningGetAllProducts = true;
    }
  } else {
    
    //console.log('from storage');
    callbackFunction(expandSizes(getFromLocalStorage()));
  }
}
